import { DOCUMENTS_URL } from 'lib/_api-helpers';
import { CreateFileSource } from 'models/inputModels/CreateTaskRequest';

type AudioPlayerProps = {
    filepath: string;
    fileSource?: CreateFileSource;
};

export default function AudioPlayer({ filepath, fileSource = 'provider' }: AudioPlayerProps): JSX.Element {
    const src = fileSource === 'provider' ? `${DOCUMENTS_URL}/${filepath}` : filepath;
    return (
        <audio
            key={filepath}
            controls
            controlsList="nodownload"
            style={{
                width: '100%',
            }}
        >
            <source src={src} type="audio/mpeg" width="100%" />
        </audio>
    );
}
